let language = {
    LOGIN_INTRO_TITLE: "QP合作伙伴计划注册",
    LOGIN_INTRO_1: "使用{{appName}}的高品质印刷技术轻松创造优质产品。",
    LOGIN_INTRO_2: "使用{{appName}}为您的业务增长赋能，实现电子商务的成功。",
    LOGIN_INTRO_3: "{{appName}}:一站式服务，满足您的所有印刷和配送需求",
};

export { language }